import {Session} from 'src/app/interfaces/session-data';

export class SetSessionStorage {
  static readonly type = '[Map] Set SessionStorage';
  constructor(public payload: Session) {}
}

export class SetPaymentKey {
  static readonly type = '[key] set paymentkey';
  constructor(public payload: string) {}
}

export class SetPaymentMethod {
  static readonly type = '[key] set paymentmethod';
  constructor(public payload: string) {}
}

export class SetPaymentStepOtt {
  static readonly type = '[step] set paymentstep';
  constructor(public payload: string) {}
}

export class SetPaymentStepAfripay {
  static readonly type = '[step] set paymentstep';
  constructor(public payload: string) {}
}

export class SetPaymentStepCard {
  static readonly type = '[step] set paymentstep';
  constructor(public payload: string) {}
}

export class SetPaymentStepMobicred {
  static readonly type = '[step] set paymentstep';
  constructor(public payload: string) {}
}

export class SetPaymentStepSecureEft {
  static readonly type = '[step] set paymentstep';
  constructor(public payload: string) {}
}

export class SetPaymentStepAdumoeft {
  static readonly type = '[step] set paymentstep';
  constructor(public payload: string) {}
}
